module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/passenger/passenger-archive/passenger-archive.component.css
// module id = ./src/app/components/passenger/passenger-archive/passenger-archive.component.css
// module chunks = main